export type Stats = {
  pages: any[];
  total_items: number;
};
export type QueryParams = {
  date_from?: any;
  date_to?: any;
};
export type NetworkObject = {
  selected?: any;
  name?: any;
};

type State = {
  limit: number;
  indexStart: number;
  indexEnd: number;
  page: number;
  reducedLimit: number;
  paginationOptions: number[];
  breadcrumbs: any;
  breadcrumbClicked: boolean;
  orderedKeys: string[];
  statCacheKeyedOnType: any;
  merchants: any;
  publishers: any;
  reportStatTypes: any;
  reportKey: any;
};

export const state: State = {
  limit: 500, // The size of API responses, perPage is for the display
  indexStart: 0,
  indexEnd: 0,
  page: 0,
  reducedLimit: 100, // Don't need to always query 500 rows, 100 improves latency
  paginationOptions: [500, 100, 50],

  // Keep track of breadcrumbs throughout megatable components
  breadcrumbs: [],
  breadcrumbClicked: false,

  // Order of params for megatable queries
  orderedKeys: [
    'date_from',
    'date_to',
    'order_by',
    'direction',
    'edit_ids',
    'auction_id',
    'edit_id',
    'search_query',
    'networks',
    'granularity',
    'merch_ids',
    'group_by',
    'is_total',
    'page',
    'per_page',
    'no_returns',
    'additional_pubs',
    'additional_merchs',
    'pub_ids',
    'auction_ids',
  ],

  // Preserves stats of megatable components
  statCacheKeyedOnType: {
    article: null, // new StatCache()
    smartlink: null,
    merchant_clicks: null,
    merchant_epc: null,
    article_graph: null,
    merchantArticle: null,
    merchantRecommendation: null,
    merchantArticle_graph: null,
    merchantRecommendation_graph: null,
    merchantTopPublisher: null,
    /*
     * Graphed rows not in current page, needed for graphed IDs in
     * the query param to be honored when not in current page of stats
     */
    article_graph_rows: null,
  },
  merchants: [],
  publishers: [],

  reportStatTypes: {
    merchantArticle: 'merchant_articles',
    merchantRecommendation: 'merchant_recommendations',
    merchantArticleSearch: 'merchant_article_search',
    merchantProductsSearch: 'article_search_products',
    article: 'articles',
    smartlink: 'smartlinks',
    merchant: 'merchants',
    product: 'products',
  },
  reportKey: null,
};
